var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_vm._t("injects"),_vm._t("question")],2),_c('main',[_vm._t("instruction"),_vm._t("fields")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }